export const koKR_tagsViewDropMenu = {
  'tagsView.operation.closeCurrent': '닫기 전류',
  'tagsView.operation.closeOther': '기타 닫기',
  'tagsView.operation.closeAll': '모두 닫기',
  'tagsView.operation.dashboard': '계기반'
};
